<template>
  <header class="w-full border-b border-blue-100 bg-white">
    <div class="container mx-auto px-4 py-6 flex justify-between items-center">
      <router-link to="/" class="text-2xl font-semibold text-blue-900">
        Fairmont Park LLC
      </router-link>
      <nav class="space-x-8">
        <router-link
            to="/"
            class="text-blue-800 hover:text-amber-500 transition-colors"
        >
          Home
        </router-link>
        <router-link
            to="/contact"
            class="text-blue-800 hover:text-amber-500 transition-colors"
        >
          Contact
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderGlobal"
}
</script>